import { render, staticRenderFns } from "./CategoriesBulkDelete.vue?vue&type=template&id=fdbaa9e4&"
import script from "./CategoriesBulkDelete.vue?vue&type=script&lang=js&"
export * from "./CategoriesBulkDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports